import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as showsCategoriesModel from './model'

export function Title(): JSX.Element {
  return <AppTitle t='series_category' />
}

const skin = era.skin('routes/shows/subcategory')

ShowCategoriesPage.displayName = 'ShowCategoriesPage'
export function ShowCategoriesPage(): JSX.Element {
  const isContentLoading = useUnit(showsCategoriesModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <Skeleton pageType='grid' isLoading={isContentLoading}>
          <ui.RenderSkin name='category' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
